/* ==========================================================================
   Newsletter - Asian American Forward Website
   ========================================================================== */

export function initializeNewsletter() {
  console.log('📧 Initializing newsletter...');

  const form = document.getElementById('newsletter-form');
  if (!form) {
    console.error('Newsletter form not found during initialization.');
    return;
  }
  console.log('✅ Newsletter form found during initialization.');

  const formStatus = document.getElementById('form-status');
  const submitButton = form.querySelector('.form-submit');
  const submitText = submitButton.querySelector('.submit-text');
  const submitLoading = submitButton.querySelector('.submit-loading');
  const notification = document.getElementById('success-notification');
  const notificationText = document.getElementById('notification-text');

  form.addEventListener('submit', async (event) => {
    console.log('🚀 Form submit event triggered.');
    event.preventDefault(); // Prevent default form submission
    console.log('🚫 Default form submission prevented.');

    // Clear previous status messages
    formStatus.textContent = '';
    formStatus.className = 'form-status'; // Reset classes

    // Show loading state
    submitButton.disabled = true;
    submitText.style.display = 'none';
    submitLoading.style.display = 'inline-block';
    submitButton.setAttribute('aria-busy', 'true');

    const formData = new FormData(form);
    const data = Object.fromEntries(formData.entries());

    try {
      // Using Formspree for form submission
      const response = await fetch('https://formspree.io/f/xkgzgdjr', {
        method: 'POST',
        headers: {
          'Accept': 'application/json'
        },
        body: JSON.stringify(data)
      });

      if (response.ok) {
        formStatus.textContent = 'Thanks for subscribing! ❤️';
        formStatus.classList.add('success');
        form.reset(); // Clear form fields
        console.log('👍 Form submitted successfully.');

        // Show success notification
        notificationText.textContent = 'Subscription Successful!';
        notification.classList.add('show');
        notification.setAttribute('aria-hidden', 'false');
        setTimeout(() => {
          notification.classList.remove('show');
          notification.setAttribute('aria-hidden', 'true');
        }, 5000); // Hide after 5 seconds

      } else {
        const errorData = await response.json();
        const errorMessage = errorData.errors ? errorData.errors.map(err => err.message).join(', ') : 'An unexpected error occurred.';
        formStatus.textContent = `Error: ${errorMessage}`;
        formStatus.classList.add('error');
        console.error('Form submission error:', errorData);
      }
    } catch (error) {
      formStatus.textContent = 'Network error. Please try again later.';
      formStatus.classList.add('error');
      console.error('Network error during form submission:', error);
    } finally {
      // Reset button state
      submitButton.disabled = false;
      submitText.style.display = 'inline-block';
      submitLoading.style.display = 'none';
      submitButton.removeAttribute('aria-busy');
    }
  });

  console.log('✅ Newsletter initialized.');
}
